var _templateObject, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _taggedTemplateLiteral(e, t) { return t || (t = e.slice(0)), Object.freeze(Object.defineProperties(e, { raw: { value: Object.freeze(t) } })); }
import styled from '@emotion/styled';
import MUISvgIcon, { svgIconClasses } from '@mui/material/SvgIcon';
import * as React from "react";
var SvgIcon = styled(MUISvgIcon)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  &.", " {\n    width: ", ";\n    height: ", ";\n    color: ", ";\n    stroke-width: 1px;\n    vector-effect: non-scaling-stroke;\n  }\n"])), svgIconClasses.root, function (_ref) {
  var size = _ref.size,
    theme = _ref.theme;
  return size && theme.size[size];
}, function (_ref2) {
  var size = _ref2.size,
    theme = _ref2.theme;
  return size && theme.size[size];
}, function (_ref3) {
  var color = _ref3.color,
    theme = _ref3.theme;
  return color && theme.color[color];
});
var SvgDiscord = function SvgDiscord(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, props, /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.19 2.297a.61.61 0 0 1 .6.424l.233.704c.036.107.16.182.29.157a9 9 0 0 1 1.694-.146 9 9 0 0 1 1.679.145c.132.025.257-.05.293-.158l.232-.702a.61.61 0 0 1 .601-.423c1.515.06 3.037.54 3.685.768.256.09.477.259.625.491.668 1.042 2.741 4.778 2.668 10.88a1.25 1.25 0 0 1-.45.968c-.622.504-2.015 1.47-4.25 2.157-.362.111-.782.01-1.013-.329-.305-.448-.572-1.018-.752-1.444a.236.236 0 0 0-.285-.13c-.78.231-1.784.408-3.033.408-1.254 0-2.263-.178-3.045-.411a.236.236 0 0 0-.284.13c-.18.427-.448.998-.754 1.447-.23.34-.65.44-1.013.329-2.235-.687-3.628-1.653-4.25-2.157a1.25 1.25 0 0 1-.45-.968c-.074-6.153 2.035-9.9 2.684-10.905a1.18 1.18 0 0 1 .575-.464c.604-.231 2.053-.716 3.72-.77m1.144 8.12c0 1.15-.84 2.083-1.875 2.083s-1.875-.932-1.875-2.083c0-1.15.84-2.083 1.875-2.083s1.875.932 1.875 2.083m3.333 0c0 1.15.84 2.083 1.875 2.083s1.875-.932 1.875-2.083c0-1.15-.84-2.083-1.875-2.083s-1.875.932-1.875 2.083",
    clipRule: "evenodd"
  }))));
};
export default SvgDiscord;